/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleTriangle = createReactComponent("circle-triangle", "IconCircleTriangle", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M12 20l7 -12h-14z", key: "svg-1" }]
]);

export { IconCircleTriangle as default };
//# sourceMappingURL=IconCircleTriangle.js.map
